import { Sheet, SheetContent } from '@folio/components';
import { useRef, useState } from 'react';
import { AccountList } from './AccountList';
import { ConnectFunnel } from './ConnectFunnel';

export type EmailAccountsDrawerView = 'accounts' | 'connect';

function DrawerBody({ initialView }: { initialView: EmailAccountsDrawerView }) {
  const [view, setView] = useState(initialView);

  return view === 'accounts' ? (
    <AccountList onConnect={() => setView('connect')} />
  ) : (
    <ConnectFunnel onExit={() => setView('accounts')} />
  );
}

export function EmailAccountsDrawer({
  view,
  onClose,
}: {
  view: EmailAccountsDrawerView | null;
  onClose: () => void;
}) {
  // The content stays rendered while the sheet slides out, after `view` is already null.
  const lastView = useRef<EmailAccountsDrawerView>('accounts');
  if (view) lastView.current = view;

  return (
    <Sheet open={view !== null} onOpenChange={open => !open && onClose()}>
      <SheetContent
        aria-describedby={undefined}
        className="flex !w-full flex-col gap-0 p-0 sm:!max-w-[440px]"
      >
        <DrawerBody initialView={lastView.current} />
      </SheetContent>
    </Sheet>
  );
}
